import IGeofence from "@/models/dto/IGeofence";

export const geofences: IGeofence[] = [
    {
        "id": 1,
        "name": "Casa",
        "description": "string",
        "area": "string",
        "calendarId": 0,
        "attributes": {}
    },
    {
        "id": 2,
        "name": "Trabajo",
        "description": "string",
        "area": "string",
        "calendarId": 0,
        "attributes": {}
    },
    {
        "id": 3,
        "name": "Almacén",
        "description": "string",
        "area": "string",
        "calendarId": 0,
        "attributes": {}
    }
]